import { useEffect, useState } from "react";
import { IFootballTeamDetail } from "../../../../commons/models/football/interface/i-football-team";
import AppTabs, { TabItem } from "../../../../commons/components/Tabs";
import { useLocation } from "react-router";
import { useAppSelector } from "../../../../hooks/app";
import { AppAvatar, AppBox, AppButton, AppPaper, AppSkeletonHeader, AppTitle } from "../../../../commons/components";
import { StatusEnum } from "../../../../commons/enums/status-enum";
import { Can } from "../../../../casl/Can";
import { ManageFootballTeam } from "../../../../commons/models/football/admin/manage-football-team";
import { RolePolicyActionEnum } from "../../../../commons/enums/role-policy-action.enum";

interface TeamManageDetailHeaderProps {
  team: ManageFootballTeam;
  onEditTeam?: (event?: Event) => void;
}

export default function TeamManageDetailHeader({ team, onEditTeam }: TeamManageDetailHeaderProps) {
  const [currentTab, setCurrentTab] = useState("");
  const [activeItem, setActiveItem] = useState<TabItem>();
  const location = useLocation();
  const { teamStatus } = useAppSelector((state) => state.footballTeamDetail);

  useEffect(() => {
    const url = location.pathname.split("/");
    setCurrentTab(url[url.length - 1]);
  }, [activeItem, location.pathname]);

  useEffect(() => {
    const lastPathSegment = location.pathname.split("/").pop();
    if (!isNaN(Number(lastPathSegment))) {
      setCurrentTab("profile");
    }
  }, [location.pathname]);

  const tabItems = [
    {
      label: "Profile",
      value: "profile",
      href: "profile",
    },
    {
      label: "Squad",
      value: "squad",
      href: "squad",
    },
    {
      label: "Events",
      value: "events",
      href: "events",
    },
    {
      label: "Statistics",
      value: "statistics",
      href: "statistics",
    },
    {
      label: "Standings",
      value: "standings",
      href: "standings",
    },
    {
      label: "Sub-teams",
      value: "sub-teams",
      href: "sub-teams",
    },
    {
      label: "Tournaments",
      value: "hosted-tournaments",
      href: "hosted-tournaments",
    },
  ];

  return (
    <AppPaper shadow="xs" padding="none">
      {teamStatus === StatusEnum.Loading ? (
        <AppSkeletonHeader withoutBackground />
      ) : (
        <AppBox
          alignItems="center"
          justifyContent="space-between"
          p="sm"
          style={{
            borderBottom: "1px solid rgb(var(--border-default))",
          }}
        >
          <AppBox alignItems="center" gap="xs">
            <AppAvatar username={team.name} size="2xl" src={team.logo || ""} />
            <AppTitle as="h4">{team.name}</AppTitle>
          </AppBox>
          <Can I={RolePolicyActionEnum.UPDATE} this={team}>
            <AppButton variant="light" label="Edit Team Info" onClick={onEditTeam} />
          </Can>
        </AppBox>
      )}
      <AppBox p="sm">
        <AppTabs
          as="a"
          onClick={(e) => {
            setActiveItem(e);
            window.scrollTo(0, 0);
          }}
          activeValue={currentTab}
          tabItems={tabItems}
        />
      </AppBox>
    </AppPaper>
  );
}
